"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ListInput_1 = require("./Input/ListInput");

var DateInput_1 = require("./Input/DateInput");

var CheckboxInput_1 = require("./Input/CheckboxInput");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var styles_1 = require("./Input/styles");

var flexStyles = require("@headspace/hs-web-style-guide/dist/flex");

var react_html_parser_1 = require("react-html-parser");

var _a = flexStyles.default,
    flex = _a.flex,
    justifyContentFlexStart = _a.justifyContentFlexStart,
    alignItemsCenter = _a.alignItemsCenter;

var createInput = function createInput(input) {
  var type = input.type,
      name = input.name,
      hasError = input.hasError,
      customInputStyles = input.customInputStyles,
      _a = input.options,
      options = _a === void 0 ? [] : _a,
      subtext = input.subtext,
      passedProps = __rest(input, ["type", "name", "hasError", "customInputStyles", "options", "subtext"]);

  switch (type) {
    case 'select':
      return React.createElement("select", __assign({
        id: name,
        name: name
      }, styles_1.inputStyles(hasError), styles_1.selectStyles(hasError), passedProps, customInputStyles), options.map(function (_a) {
        var value = _a.value,
            title = _a.title;
        return React.createElement("option", {
          key: value,
          value: value
        }, title || value);
      }));

    case 'date':
      {
        return React.createElement(DateInput_1.DateInput, __assign({
          id: name,
          hasError: hasError
        }, styles_1.dayPickerInputStyle, passedProps, {
          customInputStyles: customInputStyles
        }));
      }

    case 'textarea':
      return React.createElement("textarea", __assign({
        id: name,
        type: type || 'text'
      }, passedProps, styles_1.inputStyles(hasError), font_1.p4, styles_1.textAreaStyles(hasError), styles_1.inputOptions(customInputStyles)));

    case 'list':
      return React.createElement(ListInput_1.ListInput, __assign({
        id: name,
        hasError: hasError
      }, passedProps, {
        customInputStyles: customInputStyles
      }));

    case 'checkbox':
      return React.createElement(CheckboxInput_1.CheckboxInput, __assign({
        id: name
      }, passedProps, {
        customInputStyles: customInputStyles
      }));

    case 'review':
      return React.createElement("div", __assign({
        id: name
      }, font_1.p4, styles_1.reviewInputValueStyles, styles_1.inputOptions(customInputStyles)), passedProps.value, subtext && React.createElement("div", __assign({}, styles_1.reviewInputSubtextStyles), subtext));

    default:
      return React.createElement("input", __assign({
        id: name,
        name: name,
        type: type || 'text'
      }, passedProps, styles_1.inputStyles(hasError), font_1.p4, styles_1.inputOptions(customInputStyles)));
  }
};

exports.Input = function (_a) {
  var hasError = _a.hasError,
      errorMessage = _a.errorMessage,
      customLabelStyles = _a.customLabelStyles,
      hintLeft = _a.hintLeft,
      hintRight = _a.hintRight,
      passedProps = __rest(_a, ["hasError", "errorMessage", "customLabelStyles", "hintLeft", "hintRight"]);

  return React.createElement("div", null, React.createElement("label", __assign({}, font_1.labelRegularS, styles_1.labelStyles(hasError), styles_1.inputOptions(customLabelStyles), {
    htmlFor: passedProps.name
  }), passedProps.type !== 'checkbox' ? passedProps.label : ' '), React.createElement("div", __assign({}, flex, styles_1.dayPickerInputStyle, justifyContentFlexStart, alignItemsCenter), hintLeft && React.createElement("span", __assign({}, font_1.uiRegularM, styles_1.hintTextStyles('left')), hintLeft), createInput(Object.assign({
    hasError: hasError
  }, passedProps)), hintRight && React.createElement("span", __assign({}, font_1.uiRegularM, styles_1.hintTextStyles('right')), hintRight)), hasError ? React.createElement("span", __assign({}, font_1.uiRegularS, styles_1.errorStyles), react_html_parser_1.default(errorMessage)) : null);
};